import { render, staticRenderFns } from "./FAQLoginBonus.vue?vue&type=template&id=7903908c&scoped=true"
import script from "./FAQLoginBonus.vue?vue&type=script&lang=js"
export * from "./FAQLoginBonus.vue?vue&type=script&lang=js"
import style0 from "./FAQLoginBonus.vue?vue&type=style&index=0&id=7903908c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903908c",
  null
  
)

export default component.exports